import { Controller } from "@hotwired/stimulus";

/**
 * News feed — the next cards arrive when the reader nears the end of the
 * page, and through the « Load more » link, which stays as a fallback. The
 * cards already shown never move; a failed load leaves the link in place.
 */
export default class extends Controller {
  static targets = ["list", "more", "link"];

  moreTargetConnected(element) {
    this.observer?.disconnect();
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load();
    }, { rootMargin: "600px" });
    this.observer.observe(element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  more(event) {
    event.preventDefault();
    this.load();
  }

  async load() {
    if (this.loading || !this.hasLinkTarget) return;
    this.loading = true;
    const holder = this.moreTarget;
    try {
      const response = await fetch(this.linkTarget.href, { headers: { Accept: "text/html" }, credentials: "same-origin" });
      if (!response.ok) return;
      const html = await response.text();
      holder.remove();
      this.listTarget.insertAdjacentHTML("beforeend", html);
      window.g4sRenderIcons?.();
    } finally {
      this.loading = false;
    }
  }
}
